import { Col, Form, FormInstance, Input, Modal, Row, Table } from 'antd';
import React, { useEffect, useState } from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import InputNumberComponent from 'components/atoms/InputNumberComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import TranslateText from 'components/hoc/TranslateText';

import {
    IDodatekDFPUcetDlt,
    IDodatekDFPUcetDltPut,
    IDodatekDFPdlt,
    dokumentUcetDfpDltDelete,
    dokumentUcetDfpDltDeleteAll,
    dokumentUcetDfpDltGet,
    dokumentUcetDfpDltPost,
    dokumentUcetDfpDltPut
} from 'services/dokumenty/dfpDltTable';
import { IDodatekDFP, IDodatekDFPUcet } from 'services/dokumenty/dodatek';
import { IStavOvereni } from 'services/specialniSluzby/ueZalozeni';

import dltUcetValidation from 'utils/validations/dltUcetValidation';
import numberValidation from 'utils/validations/numberValidation';

import FormWrapper from '../FormWrapper';

export const DfpTableDlt = (
    zadostID: number,
    onDetailDisplay: () => void,
    outForm: FormInstance<any>,
    required: boolean,
    fieldsToValidate?: string[]
) => {
    const { confirm } = Modal;
    const [dataUctyDlt, setDataUctyDlt] = useState<IDodatekDFPdlt>();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [displayModeDfpDlt, setDisplayModeDfpDlt] = useState<'ucet' | 'soubor' | undefined>();
    const [refetchUcty, setRefetchUcty] = useState<boolean>(false);
    const [selectedRow, setSelectedRow] = useState<IDodatekDFPUcetDlt>();
    const [modalResp, setModalResp] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setLoading(true);
        dokumentUcetDfpDltGet(zadostID)
            .then(resp => {
                setDataUctyDlt(resp);
            })
            .catch(() => setDataUctyDlt({} as IDodatekDFP))
            .finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zadostID, refetchUcty]);

    useEffect(() => {
        setDisplayModeDfpDlt(selectedRow ? 'ucet' : undefined);
    }, [selectedRow]);

    const renderModal = () => {
        return (
            <Modal
                title={<TranslateText>SS_NOVY_RUCNI_MODAL_ZAPIS</TranslateText>}
                open={modalResp !== ''}
                onCancel={() => {
                    setModalResp('');
                }}
                footer={[
                    <Row>
                        <ButtonComponent
                            buttontext="ZAVRIT"
                            onClick={() => {
                                setModalResp('');
                            }}
                            id="zavritModalBtn"
                        />
                    </Row>
                ]}
            >
                <Row>
                    <Paragraph
                        text={
                            modalResp === 'TIMEOUT'
                                ? 'SS_SLUZBA_ERROR_NESKORO'
                                : modalResp === 'PREKROCENO'
                                  ? 'SS_NOVY_RUCNI_MODAL_RESP_PREKROCENO_PPN'
                                  : 'SS_NOVY_RUCNI_MODAL_RESP_' + modalResp
                        }
                    />
                </Row>
            </Modal>
        );
    };

    const DfpTableDltRender = () => (
        <LoadingWrapper loading={loading}>
            <Table
                rowKey={(_, index) => index || 0}
                locale={{
                    emptyText: <TranslateText>ZADNE_UDAJE</TranslateText>
                }}
                style={{
                    margin: '30px 0px'
                }}
                columns={[
                    {
                        title: <TranslateText>CISLO_MAJETKOVEHO_UCTU</TranslateText>,
                        dataIndex: 'rcma',
                        key: 'rcma'
                    },
                    {
                        title: <TranslateText>POCET_CP_PPN</TranslateText>,
                        dataIndex: 'qtet',
                        key: 'qtet'
                    },
                    {
                        dataIndex: 'iducet',
                        key: 'iducet',
                        render: (_a: string, row: IDodatekDFPUcetDlt) => (
                            <AnchorComponent
                                onClick={() => {
                                    //   outForm.resetFields(['']);
                                    onDetailDisplay();
                                    setSelectedRow(row);
                                    setIsEdit(false);
                                }}
                            >
                                <TranslateText>DETAIL</TranslateText>
                            </AnchorComponent>
                        )
                    }
                ]}
                dataSource={dataUctyDlt?.ucty}
                pagination={false}
                rowClassName={(_a, i) => {
                    const classes = [];
                    if (i % 2) classes.push('tableRowGray');
                    return classes.join(' ');
                }}
            />
            {dataUctyDlt && (
                <Row
                    style={{
                        marginTop: 10
                    }}
                >
                    <Col>
                        <Title
                            level={5}
                            text={'DOKUMENT_DODATEK_POCETCP'}
                            style={{
                                marginRight: 8
                            }}
                        />
                    </Col>
                    <Col span={4}>
                        <Input disabled={true} value={dataUctyDlt?.celkemcp} />
                    </Col>
                </Row>
            )}
            <Form.Item
                style={{
                    marginBottom: 34
                }}
                name="prilohy"
                rules={[
                    () => ({
                        validator() {
                            if (dataUctyDlt?.ucty?.length || !required) return Promise.resolve();
                            return Promise.reject(<TranslateText>DFP_UCET_ERR</TranslateText>);
                        }
                    })
                ]}
            >
                <Row className="button-row">
                    <ButtonComponent
                        id="pridatPozadavekBtn"
                        buttontext={'SS_PRIDAT_POZADAVEK'}
                        onClick={() => {
                            const action = () => {
                                onDetailDisplay();
                                setIsEdit(true);
                                setTimeout(
                                    () =>
                                        outForm.setFieldsValue({
                                            rcma: undefined,
                                            qtet: undefined
                                        }),
                                    100
                                );
                                setSelectedRow({} as IDodatekDFPUcet);
                            };
                            if (fieldsToValidate?.length) {
                                outForm.validateFields(fieldsToValidate).then(() => action());
                            } else {
                                action();
                            }
                        }}
                    />
                    <ButtonComponent
                        id="smazatBtn"
                        buttontext="SMAZAT"
                        onClick={() =>
                            confirm({
                                title: <TranslateText>DOKUMENT_DODATEK_DFP_DEL_CONFIRM_ALL</TranslateText>,
                                cancelText: <TranslateText>NE</TranslateText>,
                                okText: <TranslateText>ANO</TranslateText>,
                                onOk() {
                                    setLoading(true);
                                    dokumentUcetDfpDltDeleteAll(zadostID)
                                        .then(() => {
                                            setRefetchUcty(pv => !pv);
                                        })
                                        .finally(() => setLoading(false));
                                }
                            })
                        }
                    />
                </Row>
            </Form.Item>
        </LoadingWrapper>
    );

    const DfpUcetDltRender = () => (
        <LoadingWrapper loading={loading}>
            <FormWrapper
                outForm={outForm}
                onFinish={value => {
                    setLoading(true);
                    const dataToSend = {
                        ...value,
                        ppn: false
                    } as IDodatekDFPUcetDltPut;

                    (selectedRow?.iducet
                        ? dokumentUcetDfpDltPut(zadostID, selectedRow!.iducet, dataToSend)
                        : dokumentUcetDfpDltPost(zadostID, dataToSend)
                    )
                        .then(resp => {
                            if (resp.stavovereni === IStavOvereni.NENALEZENO && resp.stav === 'ODMITNUTO')
                                setModalResp('UCET');
                            if (resp.stavovereni === IStavOvereni.VLASTNIK && resp.stav === 'ODMITNUTO')
                                setModalResp('VLASTNIK');
                            else if (resp.sankce) setModalResp('SANKCE');
                            else if (resp.stav === 'OK') {
                                setSelectedRow(undefined);
                                setRefetchUcty(pv => !pv);
                            } else setModalResp(resp.stav);
                        })
                        .finally(() => setLoading(false));
                }}
            >
                <InputComponent
                    name="rcma"
                    label="CISLO_MAJETKOVEHO_UCTU"
                    initialValue={selectedRow?.rcma}
                    rules={dltUcetValidation()}
                    disabled={!isEdit}
                />

                <InputNumberComponent
                    name="qtet"
                    label="POCET_CP_PPN"
                    initialValue={selectedRow?.qtet}
                    maxLength={12}
                    precision={0}
                    disabled={!isEdit}
                    rules={numberValidation(true)}
                />

                {isEdit ? (
                    <Row className="button-row">
                        <ButtonComponent
                            buttontext="ZPET"
                            onClick={() => setSelectedRow(undefined)}
                            id="isinZpetBtn"
                            type="default"
                        />
                        <ButtonComponent buttontext="POKRACOVAT" htmlType="submit" id="isinPokracovatBtn" />
                    </Row>
                ) : (
                    <>
                        <Row className="button-row">
                            <ButtonComponent
                                buttontext="ZPET"
                                onClick={() => setSelectedRow(undefined)}
                                id="isinZpetBtn"
                                type="default"
                            />

                            <ButtonComponent
                                buttontext="SS_DETAIL_VYBRANY_SMAZAT"
                                onClick={() =>
                                    confirm({
                                        title: <TranslateText>DOKUMENT_DODATEK_DFP_DEL_CONFIRM</TranslateText>,
                                        cancelText: <TranslateText>NE</TranslateText>,
                                        okText: <TranslateText>ANO</TranslateText>,
                                        onOk() {
                                            setLoading(true);
                                            dokumentUcetDfpDltDelete(zadostID, selectedRow!.iducet)
                                                .then(() => {
                                                    setRefetchUcty(pv => !pv);
                                                    setSelectedRow(undefined);
                                                })
                                                .finally(() => setLoading(false));
                                        }
                                    })
                                }
                                id="isinPokracovatBtn"
                            />
                            <ButtonComponent
                                buttontext="SS_DETAIL_VYBRANY_ZMENIT"
                                htmlType="submit"
                                id="isinPokracovatBtn"
                                onClick={() => {
                                    setIsEdit(true);
                                    outForm.setFieldsValue({
                                        selectedRow
                                    });
                                }}
                            />
                        </Row>
                    </>
                )}
                {renderModal()}
            </FormWrapper>
        </LoadingWrapper>
    );

    return [DfpTableDltRender, DfpUcetDltRender, displayModeDfpDlt, dataUctyDlt] as const;
};
